import { Heading, Inline, vars } from '@etg/wings';
import { css, cx, resetButtonStyle } from '@eti/styles';
import type { ReactNode } from 'react';
import { focusStyles } from '../../../../utils/styleUtils';

const buttonStyles = (isSelected: boolean) => css`
  ${resetButtonStyle}; /* stylelint-disable-next-line */
  background-color: ${isSelected && vars.colors.inputs.hover};
  border: ${isSelected
    ? `2px solid ${vars.colors.inputs.main}`
    : `1px solid ${vars.colors.inputs.border}`};
  border-radius: ${vars.button.borderRadius};
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 64px;
  padding: 16px;
  text-align: start;
  width: 100%;

  :hover {
    background-color: ${vars.colors.inputs.hover};
  }
`;

interface TopicProps {
  'aria-controls'?: string;
  className?: string;
  icon?: ReactNode;
  id: string;
  title: string;
  onClick: () => void;
  isSelected: boolean;
}

const Topic = ({
  'aria-controls': ariaControls,
  className,
  icon,
  id,
  title,
  onClick,
  isSelected,
}: TopicProps) => {
  return (
    <button
      aria-controls={ariaControls}
      aria-expanded={isSelected}
      className={cx(buttonStyles(isSelected), focusStyles, className)}
      data-testid={`${id}-button`}
      id={id}
      onClick={onClick}
      type="button"
    >
      <Inline alignY="center" noWrap spacing={8}>
        {icon}
        <Heading as="div" level={4}>
          {title}
        </Heading>
      </Inline>
    </button>
  );
};

export default Topic;
